var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.1,147.6h-67v-27h75.3c5.1,0,9.8,2.9,12.1,7.4l43,85.6l-24.1,12.1L385.1,147.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 215.3,
    y: 338.4,
    width: 107.6,
    height: 27
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7,365.4c-7.5,0-13.5-6-13.5-13.5s6-13.5,13.5-13.5h50.2c7.5,0,13.5,6,13.5,13.5s-6,13.5-13.5,13.5H75.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.8,365.4c-7.5,0-13.5-6-13.5-13.5s6-13.5,13.5-13.5h41.1v-76l-21.6-27.8H317.1c-7.5,0-13.5-6.1-13.5-13.5l0,0V118.6 h-228c-7.5,0-13.5-6-13.5-13.5s6-13.5,13.5-13.5h241.5c7.4,0,13.5,6,13.5,13.5v102.4h106.3c4.2,0,8.1,1.9,10.6,5.2l28.5,36.7 c1.8,2.4,2.8,5.3,2.8,8.3v94.2c0,7.4-6,13.5-13.5,13.5L410.8,365.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M367.4,408.4c-31.5,0-57-25.5-57-57c0-31.5,25.5-57,57-57c31.5,0,57,25.5,57,57c0,0,0,0.1,0,0.1 C424.3,382.9,398.8,408.3,367.4,408.4z M367.4,321.4c-16.6,0-30,13.4-30,30s13.4,30,30,30s30-13.4,30-30l0,0 C397.4,334.9,383.9,321.4,367.4,321.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.4,408.4c-31.5,0-57-25.5-57-57c0-31.5,25.5-57,57-57s57,25.5,57,57c0,0,0,0,0,0C226.3,382.9,200.8,408.4,169.4,408.4z  M169.4,321.4c-16.6,0-30,13.4-30,30s13.4,30,30,30s30-13.4,30-30l0,0C199.4,334.9,185.9,321.4,169.4,321.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3,292c-7.5,0-13.5-6-13.5-13.5s6-13.5,13.5-13.5h66.6c7.5,0,13.5,6,13.5,13.5s-6,13.5-13.5,13.5H58.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,235c-7.5,0-13.5-6-13.5-13.5s6-13.5,13.5-13.5h123.6c7.5,0,13.5,6,13.5,13.5s-6,13.5-13.5,13.5H34.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3,178c-7.5,0-13.5-6-13.5-13.5s6-13.5,13.5-13.5h123.6c7.5,0,13.5,6,13.5,13.5s-6,13.5-13.5,13.5H58.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingDark);
export default __webpack_public_path__ + "static/media/shipping_dark.2fe4edb9199678b5a5333413410f3b78.svg";
export { ForwardRef as ReactComponent };